export const InawoLuxeIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.2372 1.46148C2.01951 0.901556 0.76238 2.15867 1.3223 3.37637L3.03616 7.10363C3.04543 7.12378 3.04543 7.14697 3.03616 7.16712L1.3223 10.8944C0.762384 12.1121 2.0195 13.3692 3.2372 12.8093L6.96446 11.0954C6.98461 11.0861 7.0078 11.0861 7.02795 11.0954L10.7552 12.8093C11.9729 13.3692 13.23 12.1121 12.6701 10.8944L10.9562 7.16712C10.947 7.14697 10.947 7.12378 10.9562 7.10363L12.6701 3.37638C13.23 2.15868 11.9729 0.901552 10.7552 1.46147L7.02795 3.17534C7.0078 3.1846 6.98461 3.1846 6.96446 3.17534L3.2372 1.46148Z"
        stroke="#298576"
        strokeWidth="1.36778"
      />
    </svg>
  );
};
